import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product, layout = 'scroll' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product/${product.id}`);
  };

  const wrapperClass =
    layout === 'grid'
      ? 'w-full'
      : 'flex-shrink-0 w-[calc(50%-0.375rem)] sm:w-[240px] md:w-[250px] lg:w-[240px]';

  return (
    <div className={wrapperClass}>
      <div
        className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300 cursor-pointer h-full flex flex-col"
        onClick={handleClick}
      >
        <div className="relative aspect-square overflow-hidden bg-gray-100 w-full">
          <img
            src={product.image}
            alt={product.title}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
          />
          {/* <div className="absolute top-2 left-2 text-xs font-semibold text-gray-600 opacity-50">
            PartyNestt
          </div> */}
        </div>
        <div className="p-3 sm:p-4 flex-1 flex flex-col">
          <h3 className="text-xs sm:text-base font-medium text-gray-800 line-clamp-2 min-h-[2rem] sm:min-h-[2.5rem] flex-shrink-0">
            {product.title}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;

